module.exports = __webpack_public_path__ + "static/img/zongzi.8bc5fd01.png";